import '@cohort/components-xps/xps-theme.css';
import '@cohort/wallet/index.css';
import 'react-toastify/dist/ReactToastify.css';
import '@cohort/wallet/lib/i18n';

import {defaultNetworkErrorMessage} from '@cohort/shared/models';
import {TurnstileProvider} from '@cohort/shared-frontend/providers/TurnstileProvider';
import notify from '@cohort/wallet/components/toasts/Toast';
import {initFirebase} from '@cohort/wallet/lib/Authentication';
import {initTracking} from '@cohort/wallet/lib/Tracking';
import RouterWithFlags from '@cohort/wallet/router/RouterWithFlags';
import {QueryCache, QueryClient, QueryClientProvider} from '@tanstack/react-query';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {HelmetProvider} from 'react-helmet-async';

initTracking();
initFirebase();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30, // 30 seconds
    },
  },
  queryCache: new QueryCache({
    onError: (err: unknown) => {
      let errorMessage;

      if (err instanceof Error) {
        errorMessage = err.message;
      }
      notify('error', errorMessage ?? defaultNetworkErrorMessage);
    },
  }),
});

// Configure error overlay
if (import.meta.env.DEV) {
  let overlayVisible = false;

  window.onerror = (event, source, lineno, colno, err) => {
    if (!overlayVisible && err && err.message) {
      const ErrorOverlay = customElements.get('vite-error-overlay');

      if (!ErrorOverlay) {
        return;
      }
      const overlay = new ErrorOverlay(err);

      document.body.appendChild(overlay);
      overlayVisible = true;
    }
  };
}

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <TurnstileProvider action="xps" siteKey={import.meta.env.COHORT_TURNSTILE_SITE_KEY}>
          <RouterWithFlags />
        </TurnstileProvider>
      </HelmetProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
